import React from 'react'
import PropTypes from 'prop-types'

import { Banner } from '@plurall/elo-beta'

import {
  isSchoolBrandBlockedToChangeRoles,
  isUserExternalReferenceBlockedToChangeRoles,
} from 'utils'

import styles from './IntegrationAttentionBanner.module.scss'

interface IntegrationAttentionBannerProps {
  byIntegration: boolean
  isUserByIntegration: boolean
  userExternalReference: Array<{
    applicationId: number
  }>
}

const IntegrationAttentionBanner = ({
  byIntegration,
  userExternalReference,
  isUserByIntegration,
}: IntegrationAttentionBannerProps) => {
  if (!isUserByIntegration) {
    return null
  }

  if (
    byIntegration &&
    isUserExternalReferenceBlockedToChangeRoles(userExternalReference) &&
    isSchoolBrandBlockedToChangeRoles(userExternalReference)
  ) {
    return (
      <div className={styles.banner}>
        <Banner title='Edição de função indisponível' variant='attention' secondary>
          <p>
            Não é possível editar a função devido à integração automática entre a escola e o
            Plurall. Por favor, procure a coordenação da escola para edição da função.
          </p>
        </Banner>
      </div>
    )
  }

  if (byIntegration && isSchoolBrandBlockedToChangeRoles(userExternalReference)) {
    return null
  }

  if (byIntegration) {
    return (
      <div className={styles.banner}>
        <Banner title='Edição de dados escolares indisponível' variant='attention' secondary>
          <p>Devido a integração automática, procure a escola para a alteração dos dados.</p>
        </Banner>
      </div>
    )
  }

  return null
}

export default IntegrationAttentionBanner
